import { SECONDS_IN_A_DAY } from 'constants/time'

export const getNewProductDurationRange = (newProductDurationInDays: number) => {
  const todayTimeUnix = Math.round(new Date().setHours(1, 0, 0, 0) / 1000)
  const newProductDuration = newProductDurationInDays * SECONDS_IN_A_DAY

  return [todayTimeUnix, newProductDuration]
}

export const checkIsNewPublished = (firstPublishDateUnix: number, newProductDurationInDays: number): boolean => {
  const todayTimeUnix = Math.round(new Date().setHours(1, 0, 0, 0) / 1000)

  return (todayTimeUnix - firstPublishDateUnix) / (60 * 60 * 24) < newProductDurationInDays
}

export const FILTER_BOOLEAN_OPERATOR = {
  AND: 'AND',
  OR: 'OR',
  NOT: 'NOT',
  AND_NOT: 'AND NOT',
  OR_NOT: 'OR NOT',
}

export const filterQueryBuilder = (...args: string[][]) => {
  return (
    args
      .filter((query) => query.length > 0)
      // join sub-queries by type with AND operator
      .map((query) => query.join(` ${FILTER_BOOLEAN_OPERATOR.AND} `))
      // join all types of queries with AND operator
      .join(` ${FILTER_BOOLEAN_OPERATOR.AND} `)
  )
}
